module.exports = __webpack_public_path__ + "1312b493fd802f86fa63899cc77fd072.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/minus.svg
// module id = J1Ic
// module chunks = 0